var map = {
	"./Application.jpg": 1950,
	"./Game.jpg": 1951,
	"./Music.jpg": 1952,
	"./Video.jpg": 1953,
	"./Wallpaper.jpg": 1954,
	"./Yummy Recipe.jpg": 1955,
	"./Yummy-Recipe.jpg": 1956
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 639;


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/browse ^\.\/.*\.jpg$
// module id = 639
// module chunks = 0